/**
 * humaninterval - Created by karora on 16/03/17.
 */

import { Pipe, PipeTransform } from '@angular/core';
/*
 * Format a number of seconds into a MM:SS.ddd
 */
@Pipe({
    name: 'time',
    standalone: false
})
export class TimePipe implements PipeTransform {
  transform(interval: number): string {
    if (isNaN(interval)) {
      return "??:??.?";
    }
    let seconds = interval % 60;
    interval = (interval - seconds) / 60;
    let minutes = interval % 60;
    interval = (interval - minutes) / 60;
    let hours = interval;

    let result = '';
    if (hours) {
      if (hours < 10) {
        result += '0'
      }
      result += hours + ':';
    }
    if (minutes < 10) {
      result += '0'
    }
    result += minutes + ':';
    if (seconds < 10) {
      result += '0'
    }
    result += Math.trunc(seconds);
    seconds = Math.round(seconds*10) % 10;
    result += "." + seconds;
    return result;
  }
}
